import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dExtra$dSwitch from "../Specular.Extra.Switch/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dFix from "../Specular.FRP.Fix/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Unsafe$dReference from "../Unsafe.Reference/index.js";
const withUniqDynamic_ = dictMonadFRP => dictMonadReplace => dictEq => dyn => f => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dFRP$dBase.uniqDynBy(dictMonadFRP)(dictEq.eq)(dyn))(uniq => Specular$dFRP$dReplaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(uniq)(f));
const withRefUniqDynamic_ = dictMonadFRP => dictMonadReplace => dyn => f => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dFRP$dBase.uniqDynBy(dictMonadFRP)(Unsafe$dReference.reallyUnsafeRefEq)(dyn))(uniq => Specular$dFRP$dReplaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(uniq)(f));
const whenD = dictMonadFRP => dictMonadReplace => dyn => block => withUniqDynamic_(dictMonadFRP)(dictMonadReplace)(Data$dEq.eqBoolean)(dyn)(b => {
  const $0 = dictMonadFRP.MonadCleanup1().Monad0().Applicative0();
  if (b) { return block; }
  return $0.pure();
});
const unlessD = dictMonadFRP => dictMonadReplace => dyn => block => withUniqDynamic_(dictMonadFRP)(dictMonadReplace)(Data$dEq.eqBoolean)(dyn)(b => {
  const $0 = dictMonadFRP.MonadCleanup1().Monad0().Applicative0();
  if (!b) { return block; }
  if (b) { return $0.pure(); }
  $runtime.fail();
});
const uniqDyn = dictMonadFRP => dictEq => Specular$dFRP$dBase.uniqDynBy(dictMonadFRP)(dictEq.eq);
const sample = dictMonadFRP => read => event => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(dictMonadFRP.MonadEffect0().liftEffect(read))(initial => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dFRP$dBase.newEvent(dictMonadFRP.MonadEffect0()))(update => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dFRP$dBase.subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(v => () => {
  const $0 = read();
  return update.fire($0)();
})(event))(() => Specular$dFRP$dBase.foldDyn(dictMonadFRP)(x => v => x)(initial)(update.event))));
const nextJust = dictMonadFRP => dyn => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dFRP$dBase.readDynamic(dictMonadFRP.MonadEffect0())(dyn))(currentValue => Specular$dFRP$dBase.foldDynMaybe(dictMonadFRP)($$new => old => {
  if (old.tag === "Just") { return Data$dMaybe.Nothing; }
  if (old.tag === "Nothing") {
    if ($$new.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dMaybe.$Maybe("Just", $$new._1)); }
    if ($$new.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  }
  $runtime.fail();
})(currentValue)(dyn));
const forDyn_ = dictMonadReplace => dictMonadFRP => dictFoldable => dyn => f => Specular$dFRP$dReplaceable.dynamic_(dictMonadReplace)(dictMonadFRP)(Specular$dFRP$dBase.functorDynamic.map((() => {
  const $0 = dictMonadFRP.MonadCleanup1().Monad0().Applicative0();
  return dictFoldable.foldr((() => {
    const $1 = $0.Apply0();
    return x => {
      const $2 = f(x);
      return b => $1.apply($1.Functor0().map(v => x$1 => x$1)($2))(b);
    };
  })())($0.pure());
})())(dyn));
const chain = first => second => Specular$dFRP$dFix.fixEvent({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(fired$p => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.foldDyn({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(x => v => x)(Specular$dInternal$dRIO.mapImpl(Specular$dFRP$dBase.functorEvent.map(Data$dEither.Left))(first))(Specular$dFRP$dBase.functorEvent.map((() => {
  const $0 = Specular$dInternal$dRIO.mapImpl(Specular$dFRP$dBase.functorEvent.map(Data$dEither.Right));
  return x => $0(second(x));
})())(Specular$dFRP$dBase.filterMapEvent(v => {
  if (v.tag === "Left") { return Data$dMaybe.$Maybe("Just", v._1); }
  if (v.tag === "Right") { return Data$dMaybe.Nothing; }
  $runtime.fail();
})(fired$p))))(v => Specular$dInternal$dRIO.bindImpl(Specular$dExtra$dSwitch.dynamicSwitch(Specular$dExtra$dSwitch.switchEvent)(Specular$dDom$dBuilder.monadReplaceBuilder)({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(v))(v1 => Specular$dInternal$dRIO.pureImpl(Data$dTuple.$Tuple(
  v1,
  Specular$dFRP$dBase.filterMapEvent(v$1 => {
    if (v$1.tag === "Left") { return Data$dMaybe.Nothing; }
    if (v$1.tag === "Right") { return Data$dMaybe.$Maybe("Just", v$1._1); }
    $runtime.fail();
  })(v1)
)))));
export {chain, forDyn_, nextJust, sample, uniqDyn, unlessD, whenD, withRefUniqDynamic_, withUniqDynamic_};
